/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { QuestConfigMilestone } from './QuestConfigMilestone';
import {
    QuestConfigMilestoneFromJSON,
    QuestConfigMilestoneFromJSONTyped,
    QuestConfigMilestoneToJSON,
    QuestConfigMilestoneToJSONTyped,
} from './QuestConfigMilestone';
import type { QuestDisplay } from './QuestDisplay';
import {
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestDisplayToJSONTyped,
} from './QuestDisplay';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface QuestConfigBody
 */
export interface QuestConfigBody {
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof QuestConfigBody
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * Display quest to users who have not yet met prerequisites.
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    shouldDisplayUnqualified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    requireProgressionOrder?: boolean;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof QuestConfigBody
     */
    name: string;
    /**
     * Kicker rendered above the segment name on the journey map masthead (e.g. "Get in the Game" over Boot Camp).
     * @type {string}
     * @memberof QuestConfigBody
     */
    groupLabel?: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof QuestConfigBody
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and processes event logs in BE) or not.
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof QuestConfigBody
     */
    questCompleteNotificationMessage?: string;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfigBody
     */
    questReset?: QuestReset;
    /**
     * 
     * @type {Array<QuestConfigMilestone>}
     * @memberof QuestConfigBody
     */
    milestones?: Array<QuestConfigMilestone>;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof QuestConfigBody
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigBody
     */
    rewardConfigIds?: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof QuestConfigBody
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigBody
     */
    partnerServiceIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    rewardImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigBody
     */
    backgroundImage?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigBody
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigBody
     */
    endAt?: number;
    /**
     * Per-user relative completion window in days — each user gets this many days to finish once they unlock the quest (unset = open-ended). Mutually exclusive with a reset cadence.
     * @type {number}
     * @memberof QuestConfigBody
     */
    completionWindowDays?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigBody
     */
    maxUserCompletions?: number;
    /**
     * Cheat-filtering match-bracketing gate — when true, this quest only progresses while the user has an active Match Start or Round Start in Redis
     * @type {boolean}
     * @memberof QuestConfigBody
     */
    requireActiveMatch?: boolean;
}



/**
 * Check if a given object implements the QuestConfigBody interface.
 */
export function instanceOfQuestConfigBody(value: object): value is QuestConfigBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function QuestConfigBodyFromJSON(json: any): QuestConfigBody {
    return QuestConfigBodyFromJSONTyped(json, false);
}

export function QuestConfigBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfigBody {
    if (json == null) {
        return json;
    }
    return {
        
        'displayedOn': json['displayedOn'] == null ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': json['shouldDisplayUnqualified'] == null ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': json['requireProgressionOrder'] == null ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'groupLabel': json['groupLabel'] == null ? undefined : json['groupLabel'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'questReset': json['questReset'] == null ? undefined : QuestResetFromJSON(json['questReset']),
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(QuestConfigMilestoneFromJSON)),
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'partnerServiceIds': json['partnerServiceIds'] == null ? undefined : json['partnerServiceIds'],
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'backgroundImage': json['backgroundImage'] == null ? undefined : json['backgroundImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'completionWindowDays': json['completionWindowDays'] == null ? undefined : json['completionWindowDays'],
        'maxUserCompletions': json['maxUserCompletions'] == null ? undefined : json['maxUserCompletions'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
    };
}

export function QuestConfigBodyToJSON(json: any): QuestConfigBody {
    return QuestConfigBodyToJSONTyped(json, false);
}

export function QuestConfigBodyToJSONTyped(value?: QuestConfigBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayedOn': value['displayedOn'] == null ? undefined : ((value['displayedOn'] as Array<any>).map(QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value['shouldDisplayUnqualified'],
        'requireProgressionOrder': value['requireProgressionOrder'],
        'name': value['name'],
        'groupLabel': value['groupLabel'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'questReset': QuestResetToJSON(value['questReset']),
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(QuestConfigMilestoneToJSON)),
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'partnerServiceIds': value['partnerServiceIds'],
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'backgroundImage': value['backgroundImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'completionWindowDays': value['completionWindowDays'],
        'maxUserCompletions': value['maxUserCompletions'],
        'requireActiveMatch': value['requireActiveMatch'],
    };
}

